"use client";

import { useEffect, useState } from "react";

const OverviewSection = ({ searchQuery, user }) => {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await fetch("https://leapatinternational.com/admin/api/v1/dashboard_stats.php");
        const data = await res.json();
        const formattedStats = [
          {
            id: 1,
            title: "Total categories",
            value: data?.data?.total_categories,
            change: "+12.5%",
            changeType: "positive",
            icon: "📂",
            color: "primary",
          },
          {
            id: 2,
            title: "Users",
            value: data?.data?.total_users,
            change: "+8.2%",
            changeType: "positive",
            icon: "👥",
            color: "success",
          },
          {
            id: 3,
            title: "Orders",
            value: data?.data?.order,
            change: "-2.1%",
            changeType: "negative",
            icon: "📦",
            color: "warning",
          },
          {
            id: 4,
            title: "Total Product",
            value: data?.data?.total_products,
            change: "+0.8%",
            changeType: "positive",
            icon: "🏷️",
            color: "info",
          },
        ];

        setStats(formattedStats);
      } catch (err) {
        console.error("Error fetching stats:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);
  const [recentActivities] = useState([
    { id: 1, user: "Sarah Johnson", action: "Created new project", time: "2 minutes ago", type: "create" },
    { id: 2, user: "Mike Chen", action: "Updated user profile", time: "5 minutes ago", type: "update" },
    { id: 3, user: "Emma Davis", action: "Deleted old files", time: "10 minutes ago", type: "delete" },
    { id: 4, user: "John Smith", action: "Shared document", time: "15 minutes ago", type: "share" },
    { id: 5, user: "Lisa Wang", action: "Completed task", time: "20 minutes ago", type: "complete" },
  ]);

  const [quickActions] = useState([
    { id: 1, title: "Create User", description: "Add a new user to the system", icon: "👤", color: "primary" },
    { id: 2, title: "Generate Report", description: "Create a new analytics report", icon: "📊", color: "success" },
    { id: 3, title: "Send Notification", description: "Broadcast message to users", icon: "📢", color: "warning" },
    { id: 4, title: "Backup Data", description: "Create system backup", icon: "💾", color: "info" },
  ]);

  const filteredActivities = recentActivities.filter(
    (activity) =>
      activity.user.toLowerCase().includes(searchQuery.toLowerCase()) ||
      activity.action.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const getActivityIcon = (type) => {
    switch (type) {
      case "create":
        return "➕";
      case "update":
        return "✏️";
      case "delete":
        return "🗑️";
      case "share":
        return "📤";
      case "complete":
        return "✅";
      default:
        return "📝";
    }
  };

  return (
    <div className="overview-section">
      {/* Page Header */}
      <div className="section-header">
        <div className="header-content">
          <h1 className="section-title">Dashboard </h1>
          {/* <p className="section-subtitle">Welcome back, {user.name}! Here's what's happening today.</p> */}
        </div>
        {/* <div className="header-actions">
          <button className="btn btn-outline-primary">
            <span className="btn-icon">📊</span>
            Export Data
          </button>
          <button className="btn btn-primary">
            <span className="btn-icon"> <i className="bi bi-plus-lg icon-white" style={{ color: 'white', marginRight: '5px' }}></i></span>
            Create New
          </button>
        </div> */}
      </div>

      {/* Statistics Cards */}
      <div className="stats-grid">
        {stats.map((stat) => (
          <div key={stat.id} className={`stat-card stat-card-${stat.color}`}>
            <div className="stat-card-body">
              <div className="stat-header">
                <div className="stat-icon">{stat.icon}</div>
              </div>
              <div className="stat-content">
                <h3 className="stat-value">{stat.value}</h3>
                <p className="stat-title">{stat.title}</p>
                {/* <div className={`stat-change ${stat.changeType}`}>
                  <span className="change-icon">{stat.changeType === "positive" ? "↗️" : "↘️"}</span>
                  <span className="change-value">{stat.change}</span>
                  <span className="change-period">vs last month</span>
                </div> */}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Main Content Grid */}
      {/* <div className="content-grid">
        <div className="chart-section">
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">Revenue Analytics</h5>
              <div className="card-actions">
                <select className="form-select form-select-sm">
                  <option>Last 7 days</option>
                  <option>Last 30 days</option>
                  <option>Last 3 months</option>
                </select>
              </div>
            </div>
            <div className="card-body">
              <div className="chart-container">
                <div className="chart-placeholder">
                  <div className="chart-content">
                    <div className="chart-icon">📈</div>
                    <h6>Revenue Trend</h6>
                    <p>Interactive chart would be rendered here</p>
                    <div className="chart-stats">
                      <div className="chart-stat">
                        <span className="stat-label">This Month</span>
                        <span className="stat-value">$24,580</span>
                      </div>
                      <div className="chart-stat">
                        <span className="stat-label">Last Month</span>
                        <span className="stat-value">$21,840</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="activities-section">
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">Recent Activities</h5>
              <button className="btn btn-sm btn-outline-primary">View All</button>
            </div>
            <div className="card-body">
              <div className="activities-list">
                {filteredActivities.length > 0 ? (
                  filteredActivities.map((activity) => (
                    <div key={activity.id} className="activity-item">
                      <div className="activity-icon">{getActivityIcon(activity.type)}</div>
                      <div className="activity-content">
                        <p className="activity-text">
                          <strong>{activity.user}</strong> {activity.action}
                        </p>
                        <span className="activity-time">{activity.time}</span>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="no-results">
                    <p>No activities found matching "{searchQuery}"</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="quick-actions-section">
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">Quick Actions</h5>
            </div>
            <div className="card-body">
              <div className="quick-actions-grid">
                {quickActions.map((action) => (
                  <button key={action.id} className={`quick-action-card quick-action-${action.color}`}>
                    <div className="action-icon">{action.icon}</div>
                    <div className="action-content">
                      <h6 className="action-title">{action.title}</h6>
                      <p className="action-description">{action.description}</p>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="metrics-section">
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">Performance Metrics</h5>
            </div>
            <div className="card-body">
              <div className="metrics-list">
                <div className="metric-item">
                  <div className="metric-label">Server Response Time</div>
                  <div className="metric-value">
                    <span className="value">245ms</span>
                    <div className="progress">
                      <div className="progress-bar bg-success" style={{ width: "85%" }}></div>
                    </div>
                  </div>
                </div>
                <div className="metric-item">
                  <div className="metric-label">Database Performance</div>
                  <div className="metric-value">
                    <span className="value">92%</span>
                    <div className="progress">
                      <div className="progress-bar bg-primary" style={{ width: "92%" }}></div>
                    </div>
                  </div>
                </div>
                <div className="metric-item">
                  <div className="metric-label">Memory Usage</div>
                  <div className="metric-value">
                    <span className="value">68%</span>
                    <div className="progress">
                      <div className="progress-bar bg-warning" style={{ width: "68%" }}></div>
                    </div>
                  </div>
                </div>
                <div className="metric-item">
                  <div className="metric-label">Storage Space</div>
                  <div className="metric-value">
                    <span className="value">45%</span>
                    <div className="progress">
                      <div className="progress-bar bg-info" style={{ width: "45%" }}></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default OverviewSection;
